<template>
  <div
    :class="[
      {
        dark: dark && $vuetify.theme.dark,
        light: !dark || !$vuetify.theme.dark
      },
      category.toLowerCase()
    ]"
  >
    <div ref="sr-widget" class="sr-widget sr-widget-1"></div>
  </div>
</template>

<script>
export default {
  name: 'BetRadar',
  props: {
    matchId: { type: [String, Number], default: '', required: true },
    category: { type: [String, Number], default: '', required: true },
    dark: { type: Boolean, default: true, required: false },
    collapsable: { type: Boolean, default: false, required: false }
  },
  mounted() {
    this.addWidget()
  },
  beforeDestroy() {
    this.removeWidget()
  },
  methods: {
    addWidget() {
      if (window && window.SIR) {
        let widgetType = 'match.lmtPlus'
        if (this.category === '4') {
          widgetType = 'match.lmtLight'
        } else {
          widgetType = 'match.lmtPlus'
        }
        const options = {
          showOdds: true,
          layout: 'double',
          matchId: this.matchId
        }
        if (this.collapsable) {
          options.collapseTo = 'momentum'
        }
        if (this.$refs['sr-widget']) {
          window.SIR('addWidget', this.$refs['sr-widget'], widgetType, options)
        }
      }
    },
    removeWidget() {
      if (window && window.SIR) {
        if (this.$refs['sr-widget']) {
          window.SIR('removeWidget', this.$refs['sr-widget'])
        }
      }
    }
  }
}
</script>
<style lang="scss">
@import '~/assets/styles/betradar/light.scss';
@import '~/assets/styles/betradar/dark.scss';

.sr-bb .srt-logo-powered-by-dark {
  display: none;
}

.sr-bb .sr-poweredby__link {
  display: none;
}
.sr-simcrick__momentum {
  display: none;
}

/* mobile */
// .sr-bb .sr-lmt-plus__segment.srm-timeline {
//   display: none;
// }
.tennis .sr-bb .sr-lmt-plus__segment.srm-timeline {
  display: block;
}

.sr-lmt-plus.sr-lmt-plus--double-single .sr-lmt-plus__comp-wrapper.srm-double {
  display: block;
  margin-bottom: -1px;
  position: relative;
}
.sr-scr-medium.sr-bb .sr-lmt-plus-21-scb--compact .sr-lmt-plus-21-scb__crest {
  display: none;
}
</style>
